/**
 * Recursively checks whether all tree items (including their children)
 * are selected based on the provided selected item IDs.
 * @template T - The type extending TreeItem.
 * @param {T[]} treeItems - The array of tree items to evaluate.
 * @param {string[]} [selectedItemIds] - Optional array of selected item IDs.
 * @returns {boolean} Returns true if all tree items and their children are selected.
 */
export function areAllTreeItemsSelected(treeItems, selectedItemIds) {
    if (!selectedItemIds) {
        return false;
    }
    for (const item of treeItems) {
        if (!selectedItemIds.includes(item.id)) {
            return false;
        }
        if (item.children) {
            const allSelected = areAllTreeItemsSelected(item.children, selectedItemIds);
            if (!allSelected) {
                return false;
            }
        }
    }
    return true;
}
